var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{key:_vm.url,ref:"player",attrs:{"src":_vm.url,"allow":"autoplay","width":"100%","height":"100%","frameborder":"0","loading":"lazy","allowfullscreen":"","allowtransparency":"","crossorigin":"","playsinline":""}})}
var staticRenderFns = []

export { render, staticRenderFns }